import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { ACCOUNT_INFO_API_URL } from "../constants";

const ProtectedRoute = ({ children }) => {
    const [isAuth, setIsAuth] = useState(null);

    useEffect(() => {
        const checkAuth = async () => {
            const accessToken = localStorage.getItem("access");
            if (!accessToken) {
                setIsAuth(false);
                return;
            }

            try {
                const response = await fetch(ACCOUNT_INFO_API_URL, {
                    headers: { Authorization: `Bearer ${accessToken}` },
                });

                if (response.status === 401) {
                    // Try refreshing the token
                    const refreshToken = localStorage.getItem("refresh");
                    if (refreshToken) {
                        const refreshResponse = await fetch("/api/refresh", {
                            method: "POST",
                            body: JSON.stringify({ refresh: refreshToken }),
                            headers: { "Content-Type": "application/json" },
                        });

                        if (refreshResponse.ok) {
                            const data = await refreshResponse.json();
                            localStorage.setItem("access", data.access);
                            setIsAuth(true);
                        } else {
                            setIsAuth(false);
                        }
                    } else {
                        setIsAuth(false);
                    }
                } else {
                    setIsAuth(true);
                }
            } catch (error) {
                console.error("Auth check failed:", error);
                setIsAuth(false);
            }
        };

        checkAuth();
    }, []);

    if (isAuth === null) return null; // Prevents flashing login page while checking
    return isAuth ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
